module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.modelReady) ? _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("基本信息")]), _vm._v(" "), _c('deal-and-contract', {
    attrs: {
      "model": _vm.model,
      "extra": _vm.extra,
      "mode": _vm.mode,
      "updateServicePhone": _vm.updateServicePhone,
      "errors": _vm.errors
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  }), _vm._v(" "), (_vm.extra.isBD && !_vm.isTuan) ? _c('supplierProtocol', {
    ref: "supplierProtocol",
    attrs: {
      "extra": _vm.extra,
      "supplierProtocolRule": _vm.model.supplierProtocolRule,
      "loaded": _vm.loaded
    },
    on: {
      "update:supplierProtocolRule": function($event) {
        _vm.model.supplierProtocolRule = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 2,
        right: 6
      },
      "title": "商品品类",
      "isRequired": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.mtCategory')
    },
    attrs: {
      "placeholder": "请选择品类"
    },
    model: {
      value: (_vm.model.mtCategory),
      callback: function($$v) {
        _vm.model.mtCategory = $$v
      },
      expression: "model.mtCategory"
    }
  }, _vm._l((_vm.mtCategories), function(item) {
    return (!(_vm.extra.isDirectDeal && item.value === 779)) ? _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.mtCategory')),
      expression: "validateErrors.has('tab1', 'model.mtCategory')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请选择商品品类")])], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "景点与票种",
      "isRequired": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "step-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row step-content"
  }, [_c('div', {
    staticClass: "ticket-step ticket-step-active col-sm-1"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-1 no-padding-right"
  }, [_vm._v("选择城市")]), _vm._v(" "), _c('v-select', {
    staticClass: "col-sm-6",
    attrs: {
      "filterable": "",
      "placeholder": "请先选择景点所在城市"
    },
    model: {
      value: (_vm.selectedCity),
      callback: function($$v) {
        _vm.selectedCity = $$v
      },
      expression: "selectedCity"
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('v-option', {
      key: item.locationId,
      attrs: {
        "label": item.name,
        "value": item.locationId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "row step-content"
  }, [_c('div', {
    staticClass: "ticket-step ticket-step-active col-sm-1"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-1 no-padding-right"
  }, [_vm._v("选择景点")]), _vm._v(" "), _c('v-select', {
    staticClass: "col-sm-6",
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.ticketCategory.poi')
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getPoiList,
      "disabled": _vm.selectedCity === '' || (_vm.onlineBefore && !_vm.extra.isBD),
      "placeholder": _vm.selectedCity === '' ? '请选择景点' : '请输入景点名称或poi编号'
    },
    on: {
      "change": _vm.clicked
    },
    model: {
      value: (_vm.msg),
      callback: function($$v) {
        _vm.msg = $$v
      },
      expression: "msg"
    }
  }, _vm._l((_vm.poi), function(item) {
    return _c('v-option', {
      key: item.mdcPoiId,
      attrs: {
        "label": item.placeName,
        "value": item,
        "disabled": item.accurateResult === 0
      }
    }, [(_vm.extra.isBD) ? _c('span', {
      staticClass: "local-gray-color"
    }, [_vm._v(_vm._s(item.mdcPoiId))]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.mdcPoiName))]), _vm._v(" "), (_vm.extra.isBD) ? _c('span', {
      staticClass: "local-gray-color"
    }, [_vm._v("在售" + _vm._s(item.dealCount))]) : _vm._e()])
  })), _vm._v(" "), (_vm.extra.isBD) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 如若没有景点，请在CRM中先创建新景点\n                    ")]) : _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 如若没有景点，请联系你的BD\n                    ")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.ticketCategory.poi')),
      expression: "validateErrors.has('tab1', 'model.ticketCategory.poi')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "padding-left": "11%",
      "margin-top": "-20px"
    }
  }, [_vm._v("请选择景点")]), _vm._v(" "), (_vm.model.ticketCategory && _vm.model.ticketCategory.poi.length > 0) ? _c('div', {
    staticClass: "row step-content tags"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-offset-1"
  }, _vm._l((_vm.model.ticketCategory.poi), function(tag, index) {
    return _c('v-tag', {
      key: tag.mdcPoiId,
      staticClass: "tag",
      attrs: {
        "closable": _vm.mode !== 'readonly' && !(_vm.onlineBefore && !_vm.extra.isBD),
        "type": 'success',
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleTagClose(index)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(tag.mdcPoiName) + "\n                        ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.ticketAdvices && _vm.ticketAdvices.length > 0) ? _c('div', {
    staticClass: "row step-content tags"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-offset-1"
  }, _vm._l((_vm.ticketAdvices), function(advice, index) {
    return _c('v-alert', {
      key: index,
      staticClass: "content-gap-10mg",
      attrs: {
        "title": " ",
        "type": advice.type == 3 ? 'error' : 'warning'
      },
      domProps: {
        "innerHTML": _vm._s(advice.message)
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row step-content"
  }, [_c('div', {
    staticClass: "ticket-step ticket-step-active col-sm-1"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-1 no-padding-right"
  }, [_vm._v("门票票种")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    staticClass: "col-sm-6",
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'ticketType')
    },
    attrs: {
      "placeholder": "请选择票种",
      "no-match-text": "1",
      "filterable": "",
      "disabled": _vm.model.ticketCategory && _vm.model.ticketCategory.poi && _vm.model.ticketCategory.poi.length <= 0 || (_vm.onlineBefore && !_vm.extra.isBD)
    },
    model: {
      value: (_vm.ticketType),
      callback: function($$v) {
        _vm.ticketType = $$v
      },
      expression: "ticketType"
    }
  }, _vm._l((_vm.ticketTypeList), function(item) {
    return _c('v-option', {
      key: item.value.subTicketId || item.value,
      staticClass: "custom-dropdown-with-title",
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  })), _vm._v(" "), (_vm.ticketType && _vm.ticketType.length > 0 && (!_vm.model.ticketCategory || !_vm.model.ticketCategory.subTicket || !_vm.model.ticketCategory.subTicket.ticketId)) ? _c('div', {
    staticClass: "pending-approval"
  }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 没有合适的票种？"), _c('a', {
    on: {
      "click": _vm.askForNewTicketType
    }
  }, [_vm._v("申请新票种")])]) : _vm._e()], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'ticketType')),
      expression: "validateErrors.has('tab1', 'ticketType')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "padding-left": "11%",
      "margin-top": "-20px"
    }
  }, [_vm._v("请选择票种")])])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "title": "产品名称",
      "isRequired": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-8",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.title')
    },
    attrs: {
      "type": "text",
      "name": "title",
      "placeholder": "请填写产品名称"
    },
    model: {
      value: (_vm.model.title),
      callback: function($$v) {
        _vm.model.title = $$v
      },
      expression: "model.title"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.title')),
      expression: "validateErrors.has('tab1', 'model.title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写产品名称")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 格式要求：景点名称+消费项目+适用人群 例：故宫平日门票成人票\n            ")])])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.ticketTypeStatusInfo && (_vm.ticketTypeStatusInfo.isNeed || _vm.ticketTypeStatusInfo.message)) ? _c('content-block', {
    attrs: {
      "title": "授权书"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ticketTypeStatusInfo.message))]), _vm._v(" "), (!_vm.extra.isBD && !_vm.extra.isDirect && _vm.certificateCreateUrl) ? _c('a', {
    attrs: {
      "href": _vm.certificateCreateUrl
    }
  }, [_vm._v("点此上传授权书")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "费用包含",
      "isRequired": !_vm.extra.isDirectDeal
    }
  }, [_c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]), _vm._v("费用项目包含")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]), _vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]), _vm._v("单位")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("单次时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.model.includeItems), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "cursor": "default !important"
      }
    }, [_c('td', [(!_vm.extra.isDirectDeal) ? _c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab1",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab1": true
        }
      }],
      attrs: {
        "data-key": index,
        "placeholder": "填写项目名称"
      },
      model: {
        value: (data.name),
        callback: function($$v) {
          data.name = $$v
        },
        expression: "data.name"
      }
    }) : _c('v-input', {
      attrs: {
        "data-key": index,
        "placeholder": "填写项目名称"
      },
      on: {
        "change": function($event) {
          _vm.includeErrorCheck()
        }
      },
      model: {
        value: (data.name),
        callback: function($$v) {
          data.name = $$v
        },
        expression: "data.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
      attrs: {
        "min": 1
      },
      model: {
        value: (data.count),
        callback: function($$v) {
          data.count = $$v
        },
        expression: "data.count"
      }
    })], 1), _vm._v(" "), _c('td', [(!_vm.extra.isDirectDeal) ? _c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab1",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab1": true
        }
      }],
      attrs: {
        "data-key": index
      },
      model: {
        value: (data.unit),
        callback: function($$v) {
          data.unit = $$v
        },
        expression: "data.unit"
      }
    }) : _c('v-input', {
      attrs: {
        "data-key": index
      },
      on: {
        "change": function($event) {
          _vm.includeErrorCheck()
        }
      },
      model: {
        value: (data.unit),
        callback: function($$v) {
          data.unit = $$v
        },
        expression: "data.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-input', {
      staticStyle: {
        "display": "inline-block"
      },
      style: ({
        'width': _vm.extra.isDirectDeal ? '60%' : '100%',
        'float': _vm.extra.isDirectDeal ? 'left' : 'none'
      }),
      model: {
        value: (data.timeLength),
        callback: function($$v) {
          data.timeLength = $$v
        },
        expression: "data.timeLength"
      }
    }), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('div', {
      staticStyle: {
        "float": "right",
        "width": "40%",
        "line-height": "35px"
      }
    }, [_vm._v("小时")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [(_vm.model.includeItems.length > 1) ? _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-times-circle control-icon delete click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.deleteIncludeItems(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-plus-circle control-icon click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.newIncludeItems(index)
        }
      }
    })]), _vm._v(" "), (index !== _vm.model.includeItems.length - 1) ? _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down control-icon click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.downIncludeItems(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-arrow-up control-icon click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.upIncludeItems(index)
        }
      }
    })]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "table-bottom"
  }, [_c('span', [_vm._v("项目可用数量：")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "label-inline",
    attrs: {
      "for": "r21"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isAllAvailable),
      expression: "model.isAllAvailable"
    }],
    staticClass: "v-radio",
    attrs: {
      "id": "r21",
      "name": "r2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.isAllAvailable, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.isAllAvailable = true
      }
    }
  }), _vm._v("\n                        全部可用")])]), _vm._v(" "), (_vm.model.includeItems && _vm.model.includeItems.length > 1) ? _c('span', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isAllAvailable),
      expression: "model.isAllAvailable"
    }],
    staticClass: "v-radio",
    attrs: {
      "id": "r22",
      "name": "r2",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.isAllAvailable, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.isAllAvailable = false
      }
    }
  }), _vm._v("\n                        " + _vm._s(_vm.model.includeItems.length) + "选\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "disabled": _vm.model.isAllAvailable,
      "max": _vm.model.includeItems.length - 1,
      "min": 1
    },
    model: {
      value: (_vm.model.availableCount),
      callback: function($$v) {
        _vm.model.availableCount = $$v
      },
      expression: "model.availableCount"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(" 项可用")])]) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'data.name') || _vm.validateErrors.has('tab1', 'data.unit')),
      expression: "validateErrors.has('tab1', 'data.name') || validateErrors.has('tab1', 'data.unit')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("表格包含错误")])]), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "费用包含补充说明"
    }
  }, [_c('v-input', {
    directives: [{
      name: "textarea-check",
      rawName: "v-textarea-check"
    }],
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 200,
      "placeholder": "选填，已写在费用包含中的项目请勿重复写至本栏，否则产品可能被审核人员驳回"
    },
    on: {
      "change": function($event) {
        _vm.includeErrorCheck()
      }
    },
    model: {
      value: (_vm.model.include),
      callback: function($$v) {
        _vm.model.include = $$v
      },
      expression: "model.include"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.include.length > 200 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.include.length) + "/200字")]), _vm._v(" "), _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.includeItems~model.include')),
      expression: "validateErrors.has('tab1', 'model.includeItems~model.include')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("费用包含与补充说明二者至少填其一")])], 1), _vm._v(" "), (!_vm.extra.isDirectDeal && _vm.model.ticketCategory.poi && _vm.model.ticketCategory.poi.length) ? _c('content-block', {
    attrs: {
      "title": "适用人群限制"
    }
  }, [_c('discount-des', {
    ref: "crowdOption",
    attrs: {
      "options": _vm.crowdOptionsMap,
      "extra": _vm.extra,
      "crowds": _vm.model.ticketPoiDiscounts,
      "mode": _vm.mode
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "费用不包含"
    }
  }, [_c('v-input', {
    directives: [{
      name: "textarea-check",
      rawName: "v-textarea-check"
    }],
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 150,
      "placeholder": "选填，需要额外花费才能享受的项目"
    },
    model: {
      value: (_vm.model.exclude),
      callback: function($$v) {
        _vm.model.exclude = $$v
      },
      expression: "model.exclude"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.exclude.length > 150 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.exclude.length) + "/150字")]), _vm._v(" "), _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "是否含保险",
      "isRequired": ""
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "CI1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.containInsurance),
      expression: "model.containInsurance"
    }],
    attrs: {
      "id": "CI1",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.containInsurance, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.containInsurance = false
      }
    }
  }), _vm._v("\n                    不包含")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "CI2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.containInsurance),
      expression: "model.containInsurance"
    }],
    attrs: {
      "id": "CI2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.containInsurance, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.containInsurance = true
      }
    }
  }), _vm._v(" 包含")])]), _vm._v(" "), _c('div', [(_vm.model.containInsurance) ? _c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.insuranceNote')
    },
    attrs: {
      "maxlength": 30,
      "placeholder": "请填写保险的险种以及保险公司的名称"
    },
    model: {
      value: (_vm.model.insuranceNote),
      callback: function($$v) {
        _vm.model.insuranceNote = $$v
      },
      expression: "model.insuranceNote"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.containInsurance) ? _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.insuranceNote.length) + "/30字")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.insuranceNote', 'required')),
      expression: "validateErrors.has('tab1', 'model.insuranceNote', 'required')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写保险的险种以及保险公司的名称")])], 1)])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "title": "客服电话",
      "isRequired": ""
    }
  }, [_vm._l((_vm.model.servicePhones), function(phone, index) {
    return _c('div', {
      key: index,
      staticClass: "row content-gap-10mg"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab1",
        value: ('required|tel'),
        expression: "'required|tel'",
        modifiers: {
          "tab1": true
        }
      }],
      staticClass: "form-control",
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'phone.phone', null, index)
      },
      attrs: {
        "type": "text",
        "data-key": index
      },
      model: {
        value: (phone.phone),
        callback: function($$v) {
          phone.phone = $$v
        },
        expression: "phone.phone"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab1', 'phone.phone', 'required', index)),
        expression: "validateErrors.has('tab1', 'phone.phone', 'required', index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v("请输入客服电话")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab1', 'phone.phone', 'tel', index) && !_vm.validateErrors.has('tab1', 'phone.phone', 'required', index)),
        expression: "validateErrors.has('tab1', 'phone.phone', 'tel', index) && !validateErrors.has('tab1', 'phone.phone', 'required', index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v("电话号码格式不正确")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_vm._v("\n                    客服工作时间\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.startHour),
        callback: function($$v) {
          phone.startHour = $$v
        },
        expression: "phone.startHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                    点\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.startMin),
        callback: function($$v) {
          phone.startMin = $$v
        },
        expression: "phone.startMin"
      }
    }, _vm._l((60), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                    至\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.endHour),
        callback: function($$v) {
          phone.endHour = $$v
        },
        expression: "phone.endHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                    点\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.endMin),
        callback: function($$v) {
          phone.endMin = $$v
        },
        expression: "phone.endMin"
      }
    }, _vm._l((60), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v(" "), ((_vm.mode !== 'readonly' || _vm.isTuan) && _vm.model.servicePhones && _vm.model.servicePhones.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      on: {
        "click": function($event) {
          _vm.deleteOneServicePhone(index)
        }
      }
    }) : _vm._e()], 1)])
  }), _vm._v(" "), ((_vm.mode !== 'readonly' || _vm.isTuan) && _vm.model.servicePhones && _vm.model.servicePhones.length < 3) ? _c('div', {
    staticClass: "row"
  }, [(_vm.servicePhone.length > 0) ? _c('div', {
    staticClass: "icon-link-revise col-sm-3",
    on: {
      "click": _vm.newServicePhoneFromContract
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 从合同电话中选择")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon-link-revise col-sm-3",
    on: {
      "click": _vm.newServicePhone
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增客服电话")])])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("产品图片")]), _vm._v(" "), _c('div', {
    staticClass: "row form-item"
  }, [_c('div', {
    staticClass: "col-sm-2 rowTitle"
  }, [_vm._v("产品图片")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('custom-upload', {
    attrs: {
      "url": _vm.apiHost + '/midas/common/v1/upload',
      "is-multiple": false,
      "max-limit": 5,
      "disabled": _vm.mode == 'readonly',
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": "imageList",
      "default-file-list": _vm.originImgList,
      "fileLimitSize": 2097152,
      "enable-head-image": true
    },
    on: {
      "on-max-limit": _vm.onMaxLimit,
      "on-error": _vm.onError,
      "on-success": _vm.onSuccess,
      "on-delete": _vm.onDelete,
      "on-file-size-max-limit": _vm.onSizeLimited,
      "on-set-head": _vm.onSetHeadImage
    }
  })], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo) ? _c('v-dialog', {
    attrs: {
      "title": "申请新票种",
      "size": "lg",
      "show-close": true
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "票种名称",
      "isRequired": ""
    }
  }, [_c('v-input', {
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.ticketCategoryName"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "使用人群",
      "isRequired": ""
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.usePeople),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.usePeople = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.usePeople"
    }
  }, _vm._l((_vm.usePeopleTypes), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "时间限制范围",
      "isRequired": ""
    }
  }, [_c('v-select', {
    staticClass: "col-sm-6",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRange),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRange = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.timeLimitedRange"
    }
  }, _vm._l((_vm.timeLimitedRangeTypes), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('v-input', {
    staticClass: "col-sm-6",
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "disabled": _vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRange !== 0
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "票种门市价",
      "isRequired": ""
    }
  }, [_c('v-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "上传物料类型",
      "isRequired": ""
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.uploadMaterialType"
    }
  }, _vm._l((_vm.uploadMaterialTypes), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 0) ? _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "上传物料",
      "isRequired": ""
    }
  }, [(_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 2) ? _c('v-input', {
    staticClass: "content-gap-10mg",
    attrs: {
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialText),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialText = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.uploadMaterialText"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 1) ? _c('custom-upload', {
    attrs: {
      "url": _vm.apiHost + '/midas/common/v1/upload',
      "is-multiple": false,
      "max-limit": 5,
      "disabled": _vm.mode == 'readonly',
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": "imageList",
      "fileLimitSize": 2097152,
      "default-file-list": _vm.originTicketImgList
    },
    on: {
      "on-max-limit": _vm.onMaxLimit,
      "on-error": _vm.onError,
      "on-success": _vm.onTicketUploadSuccess,
      "on-delete": _vm.onTicketUploadDelete,
      "on-file-size-max-limit": _vm.onSizeLimited
    }
  }, [_c('div', {
    staticClass: "v-upload-tips",
    slot: "tips"
  }, [_vm._v("注：高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType == 0) ? _c('div', {
    staticClass: "noUploadNotice"
  }, [_vm._v("免物料类型：在已有的票种基础上进行使用人数变更、使用时限变更、人群组合票种变更、消费项目组合票种变更")]) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": " "
    }
  }, [_c('v-button', {
    staticClass: "btn-default",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭\n            ")]), _vm._v(" "), _c('v-button', {
    staticClass: "btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.saveNewTicketType
    }
  }, [_vm._v("申请创建票种")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "选择电话",
      "size": "lg",
      "show-close": true
    },
    model: {
      value: (_vm.phoneDialogVisible),
      callback: function($$v) {
        _vm.phoneDialogVisible = $$v
      },
      expression: "phoneDialogVisible"
    }
  }, [_vm._l((_vm.servicePhone), function(phone, index) {
    return _c('div', {
      key: index,
      staticClass: "content-gap-10mg"
    }, [_c('label', {
      attrs: {
        "for": ("selectPhone" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPhone),
        expression: "selectedPhone"
      }],
      attrs: {
        "id": ("selectPhone" + index),
        "type": "checkbox"
      },
      domProps: {
        "value": phone,
        "checked": Array.isArray(_vm.selectedPhone) ? _vm._i(_vm.selectedPhone, phone) > -1 : (_vm.selectedPhone)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedPhone,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = phone,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPhone = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedPhone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPhone = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(phone.phone))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(phone.startHour) + "点" + _vm._s(phone.startMin) + "分 至 " + _vm._s(phone.endHour) + "点" + _vm._s(phone.endMin) + "分")])])])
  }), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": " "
    }
  }, [_c('v-button', {
    staticClass: "btn-default",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.phoneDialogVisible = false
      }
    }
  }, [_vm._v("关闭\n            ")]), _vm._v(" "), _c('v-button', {
    staticClass: "btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.saveServicePhoneFromContract
    }
  }, [_vm._v("保存")])], 1)], 2)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("注意事项：")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("1. 高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("2. 重要提示：图片不可有字、不可使用拼图、不可有重复图片、不可有除美团水印外的其他水印、不能有人物特写、明星宣传画等涉及人物肖像权的图片")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed40704","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Info.vue
// module id = 545
// module chunks = 0